import { render, staticRenderFns } from "./studentInformationQueryAQSCInfo.vue?vue&type=template&id=1fe84656&scoped=true"
import script from "./studentInformationQueryAQSCInfo.vue?vue&type=script&lang=js"
export * from "./studentInformationQueryAQSCInfo.vue?vue&type=script&lang=js"
import style0 from "./studentInformationQueryAQSCInfo.vue?vue&type=style&index=0&id=1fe84656&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe84656",
  null
  
)

export default component.exports